<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            class="demo-ruleForm"
            label-width="120px"
            label-position="left"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="name"
                  label="套餐来源："
                  prop="name"
                  v-if="form.id ? false : true"
                >纸质套餐</el-form-item>
                <el-form-item
                  class="el-form-item-update"
                  ref="name"
                  label="套餐来源："
                  prop="name"
                  v-else
                >
                  <el-input v-model="form.cardOldTypeCn" readonly="" placeholder="请输入套餐类型" maxlength="15"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="customerName"
                  label="客户姓名："
                  prop="customerName"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.customerName" placeholder="请输入客户姓名" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="mobile"
                  label="电话号码："
                  prop="mobile"
                  :rules="$rules.phone"
                >
                  <el-input v-model="form.mobile" placeholder="请输入电话号码" maxlength="11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="customerNo"
                  label="客户编号："
                  prop="customerNo"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.customerNo" placeholder="请输入客户编号" maxlength="8"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="cardOldId"
                  label="套餐名称："
                  prop="cardOldId"
                  :rules="$rules.changeIred"
                >
                  <el-select v-model="form.cardOldId">
                    <el-option
                      v-for="(item,index) in columns"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="originNum"
                  label="套餐次数："
                  prop="originNum"
                  :rules="$rules.zeroNumed"
                >
                  <el-input v-model="form.originNum" placeholder="请输入套餐次数" maxlength="5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {
        mobile: ""
      },
      columns: [],
      cardOldName: "",
      showPicker: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.$refs["form"].resetFields();
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        // this.$refs['form'].clearValidate();
        if (org) {
          this.addEditTitle = "编辑纸质套餐";
          this.$api
            .get(this.$url.cardOld.get, {
              id: org.id
            })
            .then(res => {
              if (res) {
                this.form = res;
                this.form.text = this.form.cardOldIdCn;
                this.cardOldName = this.form.cardOldIdCn;
                this.cardOldList();
              }
            })
            .catch(error => {});
        } else {
          this.addEditTitle = "新增纸质套餐";
          this.cardOldList();
        }
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    cardOldList() {
      this.$api
        .post(this.$url.cardOld.list)
        .then(res => {
          this.columns = res;
          this.columns.forEach(item => {
            item.name = item.name + `(提成: ${item.deductAmount})`;
          });
        })
        .catch(error => {});
    },
    onSubmit(values) {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$api
            .post(this.$url.cardOld.save, this.form)
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$refs["form"].clearValidate();
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>